import '../App.css';
import { Link, useNavigate } from 'react-router-dom';
import siteLogo from '../images/site-logo.png';
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store/auth/authActions";
import NotificationBell from './NotificationBell';

function Header() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const logoutHandler = () => {
    dispatch(logout());
    navigate("omnipod-creator-login"); 
  };

  return (
    <>
      <div className="hero__logo">
        <img src={siteLogo} alt="Omnipod Creator Marketplace logo" className="hero__logo-img" />
      </div>

      <div className="hero__actions">
        {!isAuthenticated && (<Link className="action-btn" target='_blank' to="https://admin.omnipodcreatormarketplace.com/admin/login">
          Insulet Log In
        </Link>)}
        {!isAuthenticated && (<Link className="action-btn" to="/omnipod-creator-login">
          Creator Log In
        </Link>)}

        {isAuthenticated && (
          <div className="header-right">
            <span className="user-name">
              <Link className="" to="/dashboard">
                {user?.name || "User"}
              </Link>
            </span>

            <NotificationBell />
            <button onClick={logoutHandler} className="action-btn action-btn--primary" >
              Logout
            </button>
          </div>
        )}
        {!isAuthenticated && (
          <Link className="action-btn action-btn--primary" to="/omnipod-creator-signup">
            Sign up
          </Link>
        )}

      </div>
    </>
  );
}

export default Header;
